import { Plan } from './plan';

export class PromoCode {
    promocodeId: number;
    promocodeName: string;
    maximunLimit: number;
    limitExtened: string;
    usedCount: number;
    discountType: string;
    discountAmount: number;
    expireDate: string;
    promoCodeCategory: string;
    healthCardType: string;
    healthCardFees: number;
    registrationFees: number;
    plan: Plan;
    createdAt: string;
    updatedAt: string;
}